import { useEffect } from 'react';

import { AiStates, useBulkCreateContext } from '../providers/BulkCreateContextProvider.tsx';
import { useIsConfigureLoading } from '../providers/BulkConfigureContextProvider.tsx';

import { useAIAgentStreamingData } from './useAIAgentStreamingData.tsx';

export const useAiBulkFetchIssuesList = () => {
	// eslint-disable-next-line confluence-sweet-state/sweet-state-prefer-actions-hook
	const [, { setAiState }] = useBulkCreateContext();
	const { currentAiState } = useAIAgentStreamingData();
	const { isLoading } = useIsConfigureLoading();

	useEffect(() => {
		if (currentAiState === AiStates.IDLE && isLoading) {
			return;
		}
		void setAiState(currentAiState);
	}, [currentAiState, setAiState, isLoading]);
};
